import classNames from 'classnames';
import React from 'react';

import { AlmaLink } from '../alma-link';
import * as styles from './card-layout.module.css';

interface CardLayoutProps {
	count?: number;
	ctaLink?: string;
	modalityCategoryCopy?: string;
	providers: any[];
}

export function CardLayout({
	count = 849,
	ctaLink = 'https://secure.helloalma.com/providers-results/',
	modalityCategoryCopy,
	providers,
}: CardLayoutProps) {
	return (
		<div className={styles.cardContainer}>
			<div className={styles.cardContent}>
				<div className={styles.imagesRow}>
					{providers?.map((provider) => {
						const profilePhoto = provider.profilePhoto;

						return (
							<img
								alt={provider.providerSlug}
								className={styles.avatar}
								key={provider.id}
								src={profilePhoto}
							/>
						);
					})}
				</div>
				<div className={styles.textSection}>
					<p
						className={classNames(
							'body-display-sm',
							styles.textCopy
						)}
					>
						{count.toLocaleString()} {modalityCategoryCopy} therapists
					</p>
					<p className={classNames('body-sm-caps', styles.textCopy)}>
						in the Alma directory
					</p>
				</div>
			</div>
			<AlmaLink
				cta={{
					kind: 'button',
					buttonColorTheme: 'dark',
					buttonSize: 'large',
					link: ctaLink,
					title: 'Search the directory',
				}}
			/>
		</div>
	);
}
